module.exports = __webpack_public_path__ + "static/media/stevenTrammell.483d0df6.jpg";